import * as React from 'react';

import Typography from '@mui/material/Typography';

import Props from '../../model/primary-menu-props';

export default function Primary(props: Props){
    return (
        <Typography 
                    variant="subtitle2" 
                    component="h1" 
                    color={props.isActive ? 'primary' : 'rgba(255,255,255,0.9)'}
                    sx={{
                        paddingLeft:5,
                    }} 
        >
            &lt; {props.text} &gt;
        </Typography>
    )
}